// Utilities
// import { getTimestamp } from "../utilities/getTimestamp";

export function syncLottie(array = []) {
  return Promise.all(array).then(array => {
    // console.log(getTimestamp(), "Batch loaded");
    return array;
  });
}
